module.exports = __webpack_public_path__ + "static/media/iconWhatsAppActive.1eb697b9.svg";